export function formatDocumentNumberShort(value) {
    const input = value == null ? '' : String(value).trim();
    if (!input) return '';
    return input;
}

export function truncateReference(value, maxLength = 25) {
    const input = value == null ? '' : String(value);
    if (input.length <= maxLength) return input;
    return input.slice(0, maxLength) + '…';
}
